import Vue from "vue";
import VueI18n from "vue-i18n";

import viLocale from "./vi";
import enLocale from "./en";

Vue.use(VueI18n);

const messages = {
    vi: {
        ...viLocale
    },
    en: {
        ...enLocale
    }
};

export const getLocale = (): string => {
    return 'vi';
};

const i18n = new VueI18n({
    locale: getLocale(),
    messages
});

export default i18n;